export default __webpack_public_path__ + "static/media/pantry2-after1-768w.7154a5b7.png";